/**
 *
 * Service Now Table
 *
 */

import React, { FC, useEffect } from 'react';

import { Clients } from '@ariksa/notification';
import { Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { renderTime, WithResourceIcon } from 'components/index';
import { DeleteClientModal } from 'containers/Setup/Integrations/Components/Utils/DeleteClientModal';
import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';
import { actions as clientActions } from 'containers/Setup/Integrations/slice';

export const ServiceNowTable: FC = () => {
  const { clients, client } = useSelector(selectIntegrations);
  const dispatch = useDispatch();
  const { clientActionsColumn, ...rest } = useIntegrations();

  useEffect(() => {
    dispatch(
      clientActions.loadClients({
        clientName: Clients.Servicenow,
      }),
    );
  }, [dispatch]);

  const columns = [
    {
      header: <Box pl={14}>Connector Name</Box>,
      accessor: 'name',
      render: ({ value }) => (
        <WithResourceIcon
          resourceType={Clients.Servicenow}
          iconFilled={false}
          spacing={10}
          iconSize="regular"
        >
          {value}
        </WithResourceIcon>
      ),
    },
    {
      header: 'Client ID',
      accessor: 'service_now.client_id',
      align: 'left',
    },
    {
      header: 'Instance',
      accessor: 'service_now.instance',
      align: 'left',
    },
    {
      header: 'Default Assignee',
      accessor: 'service_now.assignee',
      align: 'left',
    },
    {
      header: 'Created By',
      accessor: 'created_by',
      align: 'left',
    },
    {
      header: 'Created On',
      accessor: 'created_at',
      render: renderTime,
      align: 'left',
    },
    clientActionsColumn,
  ];

  return (
    <>
      <Table
        columns={columns}
        data={clients.servicenow}
        isLoading={clients.loading || client.isLoading}
      />
      {rest.isOpenDeleteClientModal && (
        <DeleteClientModal label="Delete ServiceNow" {...rest} />
      )}
    </>
  );
};
